var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-standard-flag"},[_vm._t("default"),(_vm.showFlag)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.tipsText,"placement":"bottom"}},[_c('span',{staticClass:"standard-flag"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }